import { useEffect, useState } from 'react'
import styles from './TopSales.module.css'
import images from '../../../assets/images'
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { BarChartItem, GenerateBarChartValue, monthNames } from '../../../helper';
import {  CircularProgress,   Menu, MenuItem } from '@mui/material';
import { useLazyQuery } from '@apollo/client';
import { GET_TOP_SALE_TICKETS } from '../api/DashboardQuery';
import ToasterWithMessage from '../../../components/shared-components/toaster';

interface TopSalesData {
  name:string,
  uv:number,
  fill:string
}
const TopSales = () => {
  const {dropdownIcon} = images;
  const [anchorEl, setAnchorEl] = useState(null);
  const [yearAnchorEl, setYearAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const yearOpen = Boolean(yearAnchorEl);
  const {error} = ToasterWithMessage()
  const [topSales, setTopSales] = useState([])
  const [barchartresponse, setBarchartResponse] = useState<BarChartItem[]>()
  const currentDate = new Date();
   
  const [month,setmonth] = useState<string>(monthNames[currentDate.getMonth()]);
  const [year,setYear] = useState<string>(String(currentDate.getFullYear()));

  const CustomYAxisTick = (props: any) => {
    const { x, y, payload } = props;
    const value = payload?.value >= 1000 ? `${payload?.value / 1000}k` : payload?.value; // Convert to 'k' format if >= 1000
    return <text x={x} y={y} dy={3} textAnchor="end" fill="#B9BDC6">{value}</text>;
  };
  const CustomToolTip = ({active,payload}:any) =>{
    if(active && payload && payload.length){
        const ticketCounts = payload[0]?.payload;
        return(
            <div className={styles.toolTipMainContainer}>
                 Tickets:
                 <span style={{color: ticketCounts?.fill}} className={styles.ticketsCount}>{ticketCounts?.uv}</span>
            </div>
        );
    }
    return null;
  }
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 27 }, (_, index) => (currentYear-2 + index));
  const handleClickOpenMenu = (e: any) =>{
    setAnchorEl(e.currentTarget);
  }
  const handleClickOpenYearMenu = (e: any) =>{
    setYearAnchorEl(e.currentTarget);
  }
  const handleCloseMenu = ()=>{
    setAnchorEl(null);
  }
  const handleCloseYearMenu = ()=>{
    setYearAnchorEl(null);
  }
  const [gettopSalesTickets, {loading}] = useLazyQuery(GET_TOP_SALE_TICKETS, {
    fetchPolicy: "no-cache",
    onCompleted: (topsalesData) => {
      setTopSales(topsalesData?.getTopSalesTickets)
    },
    onError: (err) => {
      error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    },
  });

  useEffect(()=>{
   if(topSales){
    setBarchartResponse(GenerateBarChartValue(topSales))
   }
  },[topSales])

  const handleMonthSelect = (selectedmonth: string) => {
     setmonth(selectedmonth);
     handleCloseMenu();
  }
  const handleYearSelect = (selectedYear: string) => {
    setYear(selectedYear);
    handleCloseYearMenu();
 }

  useEffect(()=>{
    gettopSalesTickets({
      variables: {
        month: month,
        year:year
      },
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[month,year])


  // const handleCheckboxChange = (event : any) => {
  //   if (event.target.name === 'labelCheckbox') {
  //     setIsActive(event.target.checked);
  //   } 
  // };

  return (
    <div className={styles.topSales}>
        <div className={styles.topSales1}>
            <div className={styles.title}>Top Sales</div>
            <div className={styles.checkboxActive}>
              {/* <div className={styles.checkbox}>
                <FormGroup>
                <FormControlLabel
                 control={<Checkbox checked={isactive} onChange={handleCheckboxChange} name="labelCheckbox" size='small'classes={{
                  root : styles.checkboxColor
                 }} 
                 sx={{ '& .MuiSvgIcon-root': { fontSize: 19 } }}
                 />}
                 label="Active Users"
                 classes={{
                  label : styles.labelStyle
                 }}
                  />
                </FormGroup>
              </div> */}
                <div className={styles.buttons} onClick={handleClickOpenMenu}>
                    <div className={styles.monthName}>{month}</div>
                    <img className={styles.icon} alt="" src={dropdownIcon} />
                </div>
                <div className={styles.buttons} onClick={handleClickOpenYearMenu}>
                    <div className={styles.monthName}>{year}</div>
                    <img className={styles.icon} alt="" src={dropdownIcon} />
                </div>
                </div>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                    "aria-labelledby": "long-button",
                    disablePadding: true,
                    }}
                    transformOrigin={{
                    horizontal: "center",
                    vertical: "top",
                    }}
                    anchorOrigin={{
                    horizontal: "center",
                    vertical: "bottom",
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleCloseMenu}
                    classes={{
                    paper: styles.monthDropdown,
                    }}
                >
                        {monthNames.map((monthName: string,index: number)=> (
                            <MenuItem 
                              key={index}
                              disableRipple
                              disableTouchRipple
                              onClick={() => handleMonthSelect(monthName)}
                              className={styles.menuItem}
                              classes={{
                                root: `${styles.menuitemhover} ${month === monthName ? styles.menuitemBg: ''}`,
                              }}
                              >
                                {monthName}
                            </MenuItem>
                        ))}
                </Menu>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                    "aria-labelledby": "long-button",
                    disablePadding: true,
                    }}
                    transformOrigin={{
                    horizontal: "center",
                    vertical: "top",
                    }}
                    anchorOrigin={{
                    horizontal: "center",
                    vertical: "bottom",
                    }}
                    anchorEl={yearAnchorEl}
                    open={yearOpen}
                    onClose={handleCloseYearMenu}
                    classes={{
                      paper: styles.monthDropdown,
                    }}
                >
                        {years.map((yearData: number,index)=> (
                            <MenuItem
                              key={index}
                              onClick={() => handleYearSelect(String(yearData))} 
                              className={styles.menuItem}
                              classes={{
                                root: `${styles.menuitemhover} ${String(yearData) === year ? styles.menuitemBg : ''}`,
                              }}
                              disableRipple
                              >
                                {yearData}
                            </MenuItem>
                        ))}
                </Menu>
          </div>
        <div className={styles.parentContainerTopSales}>
        <div style={{display: "inline-flex", flexWrap: 'wrap'}} className={styles.topSalesBarChartContainer}>
        {
          !(loading)
        ?
            <ResponsiveContainer width={(barchartresponse?.length ?? 1)*135} height={'100%'}>
                <BarChart
                    width={500}
                    height={200}
                    data={barchartresponse}
                    margin={{
                        top: 28,
                        right: 10,
                        left: -10,
                        bottom: 4,
                    }}
                    barSize={12}
                >
          <CartesianGrid vertical={false} horizontal={true} stroke="#f3f4f6" strokeDasharray="4" />
          <XAxis dataKey="name" stroke="#B9BDC6" axisLine={{ stroke: "#f3f4f6" }} tickLine={{ strokeOpacity: 0}} tick={{dy: 14}} className={styles.xaxisStyle} strokeDasharray="4" />
          <YAxis axisLine={false} tick={<CustomYAxisTick />} allowDecimals={false} className={styles.yaxisStyle} tickLine={{ strokeOpacity: 0}}/>
          <Tooltip cursor={{ fill: "transparent" }}  content={<CustomToolTip/>}/>
          <Bar dataKey="uv" radius={0}>
            {barchartresponse?.map((entry: TopSalesData, index: number) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Bar>
          </BarChart>
            </ResponsiveContainer>
        :  
            <div className={styles.topSalesCircularProgress}>
            <CircularProgress color="primary" size={30} />
            </div>
        }
        </div>
        </div>
    </div>
  )
}

export default TopSales;
